import request from "../helpers/request";

/** Komanda siyahısı: GET /api/cms/team */
export const getTeamList = async (params = {}) => {
  const response = await request.get("/api/cms/team", { params });
  return response.data;
};

/** Komanda peşələri (tablar): GET /api/cms/team-professions */
export const getTeamProfessions = async () => {
  const response = await request.get("/api/cms/team-professions");
  return response.data;
};

/** Komanda üzvü detalı: GET /api/cms/team/:id */
export const getTeamById = async (id) => {
  const response = await request.get(`/api/cms/team/${id}`);
  return response.data;
};

